import * as actionTypes from "../ActionTypes";


// Save Program
export const saveProgramRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.SAVE_PROGRAM_REQUEST,
  payload: { apiPayloadRequest }, // this nesting must match saga
  callback,
});


export const saveProgramSuccess = (data) => ({
  type: actionTypes.SAVE_PROGRAM_SUCCESS,
  payload: data,
});

export const saveProgramFailure = (error) => ({
  type: actionTypes.SAVE_PROGRAM_FAILURE,
  payload: error,
});

// Update Program
export const updateProgramRequest = (apiPayloadRequest, callback) => ({
  type: actionTypes.UPDATE_PROGRAM_REQUEST,
  payload: { apiPayloadRequest }, // ✅ required
  callback,
});


export const updateProgramSuccess = (data) => ({
  type: actionTypes.UPDATE_PROGRAM_SUCCESS,
  payload: data,
});

export const updateProgramFailure = (error) => ({
  type: actionTypes.UPDATE_PROGRAM_FAILURE,
  payload: error,
});

// Delete Program
export const deleteProgramRequest = (payload, callback) => ({
  
  type: actionTypes.DELETE_PROGRAM_REQUEST,
  payload,
  callback,
});

export const deleteProgramSuccess = (data) => ({
  type: actionTypes.DELETE_PROGRAM_SUCCESS,
  payload: data,
});

export const deleteProgramFailure = (error) => ({
  type: actionTypes.DELETE_PROGRAM_FAILURE,
  payload: error,
});
